import WithPermission from './withPermission.js';
export default WithPermission;
